<div class="container-fluid mt-4">
  <div class="row">
    <div class="col-12 col-lg-10 offset-lg-1">
      
      <!-- Header estilo Sistema de Productos -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 class="mb-1">Carga Masiva de Fees C004</h2>
          <p class="text-muted mb-0">Sistema de carga masiva para generar fees de reactivación mediante archivo Excel</p>
        </div>
      </div>

      <!-- Pestañas de navegación -->
      <ul class="nav nav-tabs mb-4" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'carga'" 
                  (click)="activeTab = 'carga'" type="button">
            <i class="fas fa-upload me-2"></i>Nueva Carga
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'historial'" 
                  (click)="activeTab = 'historial'" type="button">
            <i class="fas fa-history me-2"></i>Historial
          </button>
        </li>
      </ul>

      <!-- Contenido de pestaña: Nueva Carga -->
      <div *ngIf="activeTab === 'carga'">

      <!-- Indicador de pasos -->
      <div class="step-indicator mb-4">
        <div class="step-item" [class.active]="step === 1" [class.completed]="step > 1">
          <div class="step-circle">1</div>
          <div class="step-label">Instrucciones</div>
        </div>
        <div class="step-item" [class.active]="step === 2" [class.completed]="step > 2">
          <div class="step-circle">2</div>
          <div class="step-label">Carga</div>
        </div>
        <div class="step-item" [class.active]="step === 3" [class.completed]="step > 3">
          <div class="step-circle">3</div>
          <div class="step-label">Procesando</div>
        </div>
        <div class="step-item" [class.active]="step === 4">
          <div class="step-circle">4</div>
          <div class="step-label">Resultado</div>
        </div>
      </div>

      <!-- PASO 1: INSTRUCCIONES -->
      <div class="card shadow-sm mb-4" *ngIf="step === 1">
        <div class="card-header bg-primary text-white">
          <h5 class="mb-0"><i class="fas fa-info-circle me-2"></i>Paso 1: Instrucciones</h5>
        </div>
        <div class="card-body">
          <div class="alert alert-info">
            <h6><i class="fas fa-download me-2"></i>Descarga la Plantilla Excel</h6>
            <p class="mb-2">La plantilla contiene las instrucciones detalladas y el formato correcto para la carga masiva.</p>
            <button class="btn btn-primary btn-sm" (click)="downloadTemplate()" [disabled]="loadingTemplate">
              <span *ngIf="!loadingTemplate"><i class="fas fa-download me-2"></i>Descargar Plantilla</span>
              <span *ngIf="loadingTemplate"><span class="spinner-border spinner-border-sm me-2"></span>Descargando...</span>
            </button>
          </div>

          <h6 class="mt-4"><i class="fas fa-clipboard-list me-2"></i>Puntos Importantes:</h6>
          <ul class="list-group list-group-flush">
            <li class="list-group-item"><i class="fas fa-check text-success me-2"></i>Solo se procesarán clientes <strong>INACTIVOS</strong></li>
            <li class="list-group-item"><i class="fas fa-check text-success me-2"></i>No se validarán días de morosidad (criterio del analista)</li>
            <li class="list-group-item"><i class="fas fa-check text-success me-2"></i>Se aplicará la regla C004 de <strong>valor más alto</strong> activa</li>
            <li class="list-group-item"><i class="fas fa-check text-success me-2"></i>Los fees creados <strong>NO</strong> se desactivarán en el proceso nocturno</li>
            <li class="list-group-item"><i class="fas fa-check text-success me-2"></i>Si el cliente ya tiene un fee C004 pendiente, se omitirá</li>
          </ul>

          <h6 class="mt-4"><i class="fas fa-file-excel me-2"></i>Formato del Archivo:</h6>
          <div class="table-responsive">
            <table class="table table-sm table-bordered">
              <thead class="table-light">
                <tr>
                  <th>TIPO_CEDULA</th>
                  <th>NUMERO_CEDULA</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>V, E, J, P o G</td>
                  <td>Solo números (6-10 dígitos)</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="alert alert-warning mt-3">
            <h6><i class="fas fa-exclamation-triangle me-2"></i>Límites:</h6>
            <ul class="mb-0">
              <li>Mínimo: 1 fila</li>
              <li>Máximo: 10,000 filas por carga</li>
            </ul>
          </div>

          <div class="text-end mt-4">
            <button class="btn btn-primary" (click)="goToUpload()">
              Continuar <i class="fas fa-arrow-right ms-2"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- PASO 2: CARGA DE ARCHIVO -->
      <div class="card shadow-sm mb-4" *ngIf="step === 2">
        <div class="card-header bg-success text-white">
          <h5 class="mb-0"><i class="fas fa-upload me-2"></i>Paso 2: Cargar Archivo</h5>
        </div>
        <div class="card-body">
          
          <!-- Drag & Drop moderno -->
          <div class="mb-4">
            <label class="form-label"><strong>Seleccionar Archivo Excel</strong></label>
            <div class="drag-drop-zone" 
                 [class.drag-over]="isDragging"
                 [class.file-selected]="selectedFile"
                 (dragover)="onDragOver($event)"
                 (dragleave)="onDragLeave($event)"
                 (drop)="onDrop($event)"
                 (click)="fileInput.click()">
              
              <input #fileInput type="file" class="d-none" accept=".xlsx,.xls" (change)="onFileSelected($event)">
              
              <div class="drag-drop-content" *ngIf="!selectedFile">
                <i class="fas fa-cloud-upload-alt fa-3x text-primary mb-3"></i>
                <h5>Arrastra tu archivo aquí</h5>
                <p class="text-muted mb-2">o haz clic para seleccionar</p>
                <small class="text-muted">Solo archivos .xlsx o .xls (máx. 10,000 filas)</small>
              </div>
              
              <div class="drag-drop-content" *ngIf="selectedFile">
                <i class="fas fa-file-excel fa-3x text-success mb-3"></i>
                <h5>{{fileName}}</h5>
                <button class="btn btn-sm btn-outline-danger mt-2" (click)="removeFile($event)">
                  <i class="fas fa-times me-1"></i>Eliminar archivo
                </button>
              </div>
            </div>
          </div>

          <!-- Validación en progreso -->
          <div class="alert alert-info" *ngIf="loadingValidation">
            <span class="spinner-border spinner-border-sm me-2"></span>
            Validando archivo...
          </div>

          <!-- Resultado de validación -->
          <div *ngIf="validationResult && !loadingValidation">
            
            <!-- Archivo válido -->
            <div class="alert alert-success" *ngIf="validationResult.valid">
              <h6><i class="fas fa-check-circle me-2"></i>Archivo Válido</h6>
              <p class="mb-2">Total de filas: <strong>{{validationResult.totalRows}}</strong></p>
              
              <!-- Confirmación de permanencia -->
              <div class="form-check mt-3">
                <input class="form-check-input" type="checkbox" [(ngModel)]="confirmPermanent" id="confirmPermanent">
                <label class="form-check-label" for="confirmPermanent">
                  <strong>Entiendo que los fees creados serán permanentes</strong> y no se desactivarán automáticamente en el proceso nocturno
                </label>
              </div>
            </div>

            <!-- Archivo con errores -->
            <div class="alert alert-danger" *ngIf="!validationResult.valid">
              <h6><i class="fas fa-times-circle me-2"></i>Archivo con Errores</h6>
              <div class="validation-errors">
                <ul class="mb-0">
                  <li *ngFor="let error of validationResult.errors">{{error}}</li>
                </ul>
              </div>
            </div>

            <!-- Preview de datos -->
            <div *ngIf="filePreview.length > 0" class="mt-3">
              <h6><i class="fas fa-eye me-2"></i>Vista Previa (Primeras 10 filas)</h6>
              <div class="file-preview-table">
                <table class="table table-sm table-bordered">
                  <thead class="table-light">
                    <tr>
                      <th>TIPO_CEDULA</th>
                      <th>NUMERO_CEDULA</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of filePreview">
                      <td>{{row.TIPO_CEDULA}}</td>
                      <td>{{row.NUMERO_CEDULA}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between mt-4">
            <button class="btn btn-secondary" (click)="backToInstructions()">
              <i class="fas fa-arrow-left me-2"></i>Volver
            </button>
            <button class="btn btn-success" (click)="submitBatch()" 
                    [disabled]="!selectedFile || !validationResult?.valid || !confirmPermanent || loadingUpload">
              <span *ngIf="!loadingUpload"><i class="fas fa-rocket me-2"></i>Procesar Carga Masiva</span>
              <span *ngIf="loadingUpload"><span class="spinner-border spinner-border-sm me-2"></span>Procesando...</span>
            </button>
          </div>
        </div>
      </div>

      <!-- PASO 3: PROCESANDO -->
      <div class="card shadow-sm mb-4" *ngIf="step === 3">
        <div class="card-header bg-info text-white">
          <h5 class="mb-0"><i class="fas fa-cog fa-spin me-2"></i>Paso 3: Procesando</h5>
        </div>
        <div class="card-body">
          <div class="progress-container">
            <div class="progress-circle" [style.--progress]="progress + '%'">
              <div class="progress-inner">
                {{progress}}%
              </div>
            </div>
            <h5>Procesando carga masiva...</h5>
            <p class="text-muted">Por favor espera mientras se procesan los fees</p>
            <div class="spinner-border text-primary mt-3" role="status">
              <span class="visually-hidden">Cargando...</span>
            </div>
          </div>
        </div>
      </div>

      <!-- PASO 4: RESULTADO -->
      <div class="card shadow-sm mb-4" *ngIf="step === 4 && batchResult">
        <div class="card-header" [class.bg-success]="batchResult.status === 'COMPLETED'" 
                                  [class.bg-danger]="batchResult.status === 'ERROR'"
                                  [class.text-white]="true">
          <h5 class="mb-0">
            <i class="fas" [class.fa-check-circle]="batchResult.status === 'COMPLETED'"
                          [class.fa-times-circle]="batchResult.status === 'ERROR'" class="me-2"></i>
            Paso 4: Resultado
          </h5>
        </div>
        <div class="card-body">
          
          <!-- Información del lote -->
          <div class="mb-4">
            <h6><i class="fas fa-info-circle me-2"></i>Información del Lote</h6>
            <div class="row">
              <div class="col-md-6">
                <p class="mb-1"><strong>Número de Lote:</strong> {{batchResult.batch_number}}</p>
                <p class="mb-1"><strong>Nombre:</strong> {{batchResult.batch_name || 'Sin nombre'}}</p>
              </div>
              <div class="col-md-6">
                <p class="mb-1"><strong>Creado por:</strong> {{batchResult.created_by_name}}</p>
                <p class="mb-1"><strong>Fecha:</strong> {{batchResult.created_at | date:'dd/MM/yyyy HH:mm'}}</p>
              </div>
            </div>
          </div>

          <!-- Resumen de resultados -->
          <div class="result-summary">
            <div class="result-card success">
              <div class="result-number text-success">{{batchResult.successful_fees}}</div>
              <div class="result-label text-success">Éxitos</div>
            </div>
            <div class="result-card error">
              <div class="result-number text-danger">{{batchResult.failed_fees}}</div>
              <div class="result-label text-danger">Errores</div>
            </div>
            <div class="result-card skipped">
              <div class="result-number text-warning">{{batchResult.skipped_fees}}</div>
              <div class="result-label text-warning">Omitidos</div>
            </div>
          </div>

          <!-- Botones de acción -->
          <div class="d-flex justify-content-center gap-3">
            <button class="btn btn-primary btn-lg" (click)="downloadResult()" *ngIf="batchResult.output_file_cloudinary_url">
              <i class="fas fa-download me-2"></i>Descargar Reporte
            </button>
            <button class="btn btn-success btn-lg" (click)="finishAndReset()">
              <i class="fas fa-check-circle me-2"></i>Finalizar
            </button>
          </div>
        </div>
      </div>

      </div><!-- Fin pestaña Nueva Carga -->

      <!-- Contenido de pestaña: Historial -->
      <div *ngIf="activeTab === 'historial'">

      <!-- HISTORIAL DE LOTES -->
      <div class="card shadow-sm">
        <div class="card-header bg-dark text-white">
          <h5 class="mb-0"><i class="fas fa-history me-2"></i>Historial de Lotes</h5>
        </div>
        <div class="card-body">
          
          <!-- Filtros -->
          <div class="row mb-3">
            <div class="col-md-3">
              <label class="form-label">Fecha Inicio</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="filterStartDate">
            </div>
            <div class="col-md-3">
              <label class="form-label">Fecha Fin</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="filterEndDate">
            </div>
            <div class="col-md-3">
              <label class="form-label">Estado</label>
              <select class="form-control form-control-sm" [(ngModel)]="filterStatus">
                <option value="">Todos</option>
                <option value="COMPLETED">Completado</option>
                <option value="PROCESSING">Procesando</option>
                <option value="ERROR">Error</option>
                <option value="PENDING">Pendiente</option>
              </select>
            </div>
            <div class="col-md-3 d-flex align-items-end">
              <button class="btn btn-primary btn-sm me-2" (click)="applyFilters()">
                <i class="fas fa-filter me-1"></i>Filtrar
              </button>
              <button class="btn btn-secondary btn-sm" (click)="clearFilters()">
                <i class="fas fa-times me-1"></i>Limpiar
              </button>
            </div>
          </div>

          <!-- Tabla de lotes -->
          <div class="table-responsive">
            <table class="table table-hover batch-table">
              <thead>
                <tr>
                  <th>Número de Lote</th>
                  <th>Nombre</th>
                  <th>Creado por</th>
                  <th>Fecha</th>
                  <th>Total</th>
                  <th>Éxitos</th>
                  <th>Errores</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="loadingHistory">
                  <td colspan="9" class="text-center">
                    <span class="spinner-border spinner-border-sm me-2"></span>Cargando...
                  </td>
                </tr>
                <tr *ngIf="!loadingHistory && batches.length === 0">
                  <td colspan="9" class="text-center text-muted">No hay lotes registrados</td>
                </tr>
                <tr *ngFor="let batch of batches" class="cursor-pointer" (click)="viewBatchDetail(batch._id)">
                  <td><strong>{{batch.batch_number}}</strong></td>
                  <td>{{batch.batch_name || '-'}}</td>
                  <td>{{batch.created_by_name}}</td>
                  <td>{{batch.created_at | date:'dd/MM/yyyy HH:mm'}}</td>
                  <td>{{batch.total_rows}}</td>
                  <td class="text-success"><strong>{{batch.successful_fees}}</strong></td>
                  <td class="text-danger"><strong>{{batch.failed_fees}}</strong></td>
                  <td>
                    <span [class]="getStatusBadgeClass(batch.status)">
                      {{getStatusText(batch.status)}}
                    </span>
                  </td>
                  <td>
                    <button class="btn btn-sm btn-primary" (click)="downloadBatchResult(batch); $event.stopPropagation()"
                            *ngIf="batch.output_file_cloudinary_url">
                      <i class="fas fa-download"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Paginación -->
          <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="totalPages > 1">
            <div>
              Página {{currentPage}} de {{totalPages}}
            </div>
            <div>
              <button class="btn btn-sm btn-secondary me-2" (click)="changePage(currentPage - 1)" 
                      [disabled]="currentPage === 1">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button class="btn btn-sm btn-secondary" (click)="changePage(currentPage + 1)" 
                      [disabled]="currentPage === totalPages">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      </div><!-- Fin pestaña Historial -->

    </div>
  </div>
</div>
